import { display, ResponsiveValue } from 'styled-system';
import { applyTransientProps } from './styled-system-helpers';

export type DisplayValue = 'block' | 'inline' | 'inline-block' | 'flex' | 'inline-flex' | 'grid' | 'inline-grid';

export type StyledDisplayProps = {
  $display?: ResponsiveValue<DisplayValue>;
};

export const styledDisplay = <T extends StyledDisplayProps>(props: T) => applyTransientProps(props, display);
